var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa320a3465d9fb6f1c8bfeaadb9c10d4e0a00d07"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["toaster-frontend-v2@phiture-eng"]={id:"aa320a3465d9fb6f1c8bfeaadb9c10d4e0a00d07"};
      